import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/agentcore')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/integrations/agent-connections',
      params: { organizationName: params.organizationName },
    });
  },
});
